import { boolean, object, string } from "yup";

export const manualBankAccountSchema = object({
  name: string().required("Please enter bank name"),
  account_number: string().required("Please enter account number"),
  routing_number: string()
    .required("Please enter routing number")
    .matches(/^.{9}$/, "Routing number must be exactly 9 characters"),
  bank_details_entity_name: string().required(
    "Please enter the account holder's name"
  ),
  address: string().required("Please add an address"),
  is_confirmed: boolean().oneOf(
    [true],
    "Please confirm the details are accurate"
  ),
});
